import * as Actions from 'reducks/manufacturer/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const ManufacturerReducer = (state = initialState.manufacturer, action: any) => {
  switch (action.type) {
    case Actions.FETCH_MANUFACTURERS:
      return {
        ...state,
        manufacturers: [...action.payload],
      }
    case Actions.HANDLE_MANUFACTURERS:
      return {
        ...state,
        manufacturers: [...action.payload],
      }
    case Actions.INIT_MANUFACTURERS:
      return {
        ...initialState.manufacturer,
      }
    case Actions.SAVE_MANUFACTURER_STORES:
      return {
        ...state,
        manufacturerStores: [...action.payload],
      }
    default:
      return state
  }
}
